export class ProgramArticlePictureRequest {
  ValEmiId: number;
  ChannelId: number;
  DestinationId: number;
  SetId: number;
  LanIds: number[];

  constructor(data: {
    ValEmiId: number;
    ChannelId: number;
    DestinationId: number;
    SetId: number;
    LanIds: number[];
  }) {
    this.ValEmiId = data.ValEmiId;
    this.ChannelId = data.ChannelId;
    this.DestinationId = data.DestinationId;
    this.SetId = data.SetId;
    this.LanIds = data.LanIds;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/programArticlePictureRequest.ts